import { InjectionToken, Provider, Type } from '@angular/core';
import { IStaticStylesConfig } from '../skins/_primitives/IStaticStylesConfig';

/**
 * Contrat qu'un écran "hôte de champs" (typiquement un GenetricDetailComponent)
 * fournit aux <app-field-wrapper> de son template.
 *
 * Fourniture du contexte, au choix :
 *  - via la directive : <div [fieldContext]="this"> ... </div>   (recommandé)
 *  - via le token     : providers: [provideFieldHost(MonDetailComponent)]
 *
 * Les wrappers résolvent leur hôte selon la chaîne :
 * inputs explicites (legacy) > [fieldContext] ancêtre > FIELD_HOST > erreur claire.
 */
export interface IFieldHost {
  editingEntity(): any;
  isEditMode(): boolean;
  flashingProperty(): string | null;
  totalModifiedCount(): number;
  getModifiedFieldIndex(property: string): number;
  propretyHasChanged(property: string): boolean;
  toggleUndo(property: string): void;
  triggerFlash(property: string): void;
  hasValidationErrors(property: string): boolean;
  getValidationErrors(property: string): string[];
  Skin: IStaticStylesConfig;
}

export const FIELD_HOST = new InjectionToken<IFieldHost>('FIELD_HOST');

/** Variante "providers" : { providers: [provideFieldHost(MonDetailComponent)] } dans le décorateur. */
export function provideFieldHost(hostType: Type<IFieldHost>): Provider {
  return { provide: FIELD_HOST, useExisting: hostType };
}
